import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from '@fortawesome/pro-regular-svg-icons/faSave'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp'

import { DropdownMenu } from './styled'

export const Save = ({ onSave }) => {
    return (
        <button title="Save" className="btn" onClick={() => onSave()}>
            <FontAwesomeIcon icon={faSave} />
        </button>
    )
}

export const SaveAndIndex = ({ onSave }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false)
    return (
        <div className="dropdown">
            <button
                title="Save"
                data-testid="content-dropdown-save"
                className={`btn ${dropdownOpen ? 'btn-active' : ''}`}
                data-toggle="dropdown"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                style={{ width: '45px' }}
            >
                <FontAwesomeIcon icon={faSave} />
                <FontAwesomeIcon
                    icon={dropdownOpen ? faChevronUp : faChevronDown}
                    size="xs"
                    className="!ml-1"
                />
            </button>
            <DropdownMenu className={`${dropdownOpen ? '!block' : ''}`}>
                <a
                    className="dropdown-item cursor-pointer"
                    data-testid="content-save"
                    onClick={async e => {
                        e.preventDefault()
                        await onSave()
                        setDropdownOpen(false)
                    }}
                >
                    Save
                </a>
                <a
                    className="dropdown-item cursor-pointer"
                    data-testid="content-save-index"
                    onClick={async e => {
                        e.preventDefault()
                        await onSave(true)
                        setDropdownOpen(false)
                    }}
                >
                    Save and Index
                </a>
            </DropdownMenu>
        </div>
    )
}
